<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="100px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="优惠券名称">
                <el-input style="width: 180px" v-model="queryForm.couponName"></el-input>
            </el-form-item>
            <el-form-item label="所属商品">
                <el-input style="width: 180px" v-model="queryForm.productId"></el-input>
            </el-form-item>
            <el-form-item label="券包类型">
                <el-select
                    class="selectInput"
                    v-model="queryForm.couponType"
                    size="small"
                    placeholder="请选择类型"
                    clearable
                    style="width: 180px"
                >
                    <el-option v-for="item in couponTypeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopCouponList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopCoupon">新建</el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopCoupon(null)"
                    >删除</el-button
                    >
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshShopCouponList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table :data="shopCouponList" row-key="id" height='100%' @selection-change="handleSelectionChange" size="small">
                <el-table-column align="center" type="selection" width="60px"> </el-table-column>

                <el-table-column :show-overflow-tooltip="true" align="center" prop="couponName" label="优惠券名称" width="100px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="couponMoney" label="优惠券额度" width="100px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="receiveExpire" label="领取截止时间" width="180px">
                    <template slot-scope="scpe">
                        {{ $moment(scpe.row.receiveExpire).format('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="useExpire" label="使用截止时间" width="180px">
                    <template slot-scope="scpe">
                        {{ $moment(scpe.row.useExpire).format('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="couponAmount" label="优惠券数量" width="150px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="receiveAmount" label="已领取数量" width="150px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="couponType" label="优惠券品类" width="150px">
                    <template slot-scope="scop">
                        <div>
                            {{ computeCouponTarget(scop.row.couponTarget) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="couponType" label="优惠券类型" width="150px">
                    <template slot-scope="scop">
                        <div>
                            {{ computeCouponType(scop.row.couponType) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="productId" label="所属目标" width="150px">
                    <template slot-scope="scop">
                        <div v-if="scop.row.shopProduct && scop.row.couponTarget == 2">
                            所属商品:{{ scop.row.shopProduct.productName }}
                        </div>
                        <div v-else-if="scop.row.shopCategory && scop.row.couponTarget == 3">
                            所属品类:{{ scop.row.shopCategory.categoryName }}
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <!--                <el-table-column :show-overflow-tooltip="true" align="center" prop="productId" label="所属品类" width="150px">-->
                <!--                    <template slot-scope="scop">-->
                <!--                        <div v-if="scop.row.shopCategory">-->
                <!--                            {{ scop.row.shopCategory.categoryName }}-->
                <!--                        </div>-->
                <!--                        <div v-else>&#45;&#45;</div>-->
                <!--                    </template>-->
                <!--                </el-table-column>-->
                <el-table-column :show-overflow-tooltip="true" align="center" prop="useRequire" label="满足金额" width="150px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间" width="180px">
                    <template slot-scope="scpe">
                        {{ $moment(scpe.row.createTime).format('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="400px">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="shopCouponRecord(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular/>
                                </Icon>
                                <span class="operation-label">查看领取记录</span>
                            </div>
                            <div @click="checkShopCoupon(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular/>
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editShopCoupon(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular/>
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteShopCoupon(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular/>
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog :title="shopCouponStates[shopCouponState]" :visible.sync="showDialog" width="60%" @close="closeDialog">
                <div>
                    <el-form :model="shopCoupon" ref="shopCouponForm" :rules="rules" label-width="150px" :inline="true" size="small">
                        <el-form-item label="优惠券名称" prop="couponName">
                            <el-input
                                size="small"
                                style="width: 180px"
                                v-model="shopCoupon.couponName"
                                :disabled="shopCouponState == 'check'"
                                placeholder="请输入优惠券名称"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="优惠券额度" prop="couponMoney">
                            <el-input
                                size="small"
                                style="width: 180px"
                                v-model="shopCoupon.couponMoney"
                                :disabled="shopCouponState == 'check'"
                                placeholder="请输入优惠券额度"
                            ></el-input>
                        </el-form-item>
                        <!--                        <el-form-item label="券包发放时间" prop="grantTime">-->
                        <!--                            <el-date-picker-->
                        <!--                                clearable-->
                        <!--                                value-format="yyyy-MM-dd HH:mm:ss"-->
                        <!--                                style="width: 175px"-->
                        <!--                                v-model="shopCoupon.grantTime"-->
                        <!--                                type="datetime"-->
                        <!--                                :picker-options="disabledCurrentDate"-->
                        <!--                                placeholder="选择券包发放时间"-->
                        <!--                                :disabled="shopCouponState == 'check'"-->
                        <!--                                size="small"-->
                        <!--                            ></el-date-picker>-->
                        <!--                        </el-form-item>-->
                        <el-form-item label="领取截止时间" prop="receiveExpire">
                            <el-date-picker
                                clearable
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width: 180px"
                                v-model="shopCoupon.receiveExpire"
                                type="datetime"
                                :picker-options="disabledGrantTime"
                                placeholder="选择领取截止时间"
                                :disabled="shopCouponState == 'check'"
                                size="small"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="使用截止时间" prop="useExpire">
                            <el-date-picker
                                clearable
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width: 180px"
                                v-model="shopCoupon.useExpire"
                                type="datetime"
                                placeholder="选择使用截止时间"
                                :picker-options="disabledReceiveExpire"
                                :disabled="shopCouponState == 'check'"
                                size="small"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="优惠券数量" prop="couponAmount">
                            <el-input
                                size="small"
                                style="width: 180px"
                                v-model="shopCoupon.couponAmount"
                                :disabled="shopCouponState == 'check'"
                                placeholder="请输入优惠券数量"
                            ></el-input>
                        </el-form-item>
                        <!--                        <el-form-item label="券包剩余数量" prop="surplusAmount">-->
                        <!--                            <el-input-->
                        <!--                                size="small"-->
                        <!--                                v-model="shopCoupon.surplusAmount"-->
                        <!--                                :disabled="shopCouponState == 'check'"-->
                        <!--                                placeholder="请输入券包剩余数量"-->
                        <!--                            ></el-input>-->
                        <!--                        </el-form-item>-->
                        <el-form-item label="已领取数量" prop="receiveAmount">
                            <el-input
                                size="small"
                                style="width: 180px"
                                v-model="shopCoupon.receiveAmount"
                                :disabled="shopCouponState == 'check'"
                                placeholder="请输入已领取数量"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="优惠券品类" prop="couponTarget">
                            <el-select
                                v-model="shopCoupon.couponTarget"
                                size="small"
                                style="width: 180px"
                                :disabled="shopCouponState == 'check'"
                                placeholder="请选择优惠券品类"
                            >
                                <el-option v-for="item in couponTargetList" :key="item.key" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="商品分类" prop="categoryId" v-if="shopCoupon.couponTarget == 3">
                            <el-select
                                :disabled="shopCouponState == 'check'"
                                style="width: 180px"
                                v-model="shopCoupon.categoryId"
                                placeholder="请选择"
                                clearable
                                size="small"
                                @change="couponTargetChange"
                            >
                                <el-tree node-key="id" :default-expanded-keys="expands" :data="shopProductCategoryList" :props="treeProps" @bn>
                                    <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                                        <el-option :label="node.label" :value="data.id"> </el-option>
                                    </div>
                                </el-tree>
                            </el-select>
                        </el-form-item>


                        <el-form-item label="指定商品" prop="productId" v-if="shopCoupon.couponTarget == 2">
                            <GridSelectLi
                                style="width: 180px"
                                title="指定商品"
                                labelName="productName"
                                labelValue="id"
                                :did="did"
                                :value="shopCoupon.productId"
                                :limit="1"
                                size="small"
                                placeholder="请选择商品"
                                @getValue="getValueProductId"
                                :columns="PRODUCT_code"
                                :searchs="PRODUCT_search"
                                dataListUrl="/washcloud/product/findList"
                                entityBeanName="shopProduct"
                                queryEntityUrl="/washcloud/product/get"
                            >
                            </GridSelectLi>
                        </el-form-item>

                        <el-form-item label="优惠券类型" prop="couponType">
                            <el-select
                                v-model="shopCoupon.couponType"
                                size="small"
                                style="width: 180px"
                                :disabled="shopCouponState == 'check'"
                                placeholder="请选择优惠券类型"
                            >
                                <el-option v-for="item in couponTypeList" :key="item.key" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="满足金额" prop="useRequire" v-if="shopCoupon.couponType == 1">
                            <el-input
                                size="small"
                                style="width: 180px"
                                v-model="shopCoupon.useRequire"
                                :disabled="shopCouponState == 'check'"
                                placeholder="请填写优惠券满足金额"
                            ></el-input>
                        </el-form-item>
                        <!--                        <el-form-item label="券包图片" prop="couponPhoto">-->
                        <!--                            <el-upload-->
                        <!--                                action=""-->
                        <!--                                :disabled="shopCouponState == 'check'"-->
                        <!--                                class="avatar-uploader"-->
                        <!--                                :show-file-list="false"-->
                        <!--                                :http-request="uploadAvatar"-->
                        <!--                                style="width: 200px"-->
                        <!--                            >-->
                        <!--                                <img v-if="shopCoupon.couponPhoto" :src="shopCoupon.couponPhoto" class="avatar" />-->
                        <!--                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
                        <!--                            </el-upload>-->
                        <!--                        </el-form-item>-->
                    </el-form>
                </div>
                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="shopCouponState != 'check'">确定</el-button>
                </div>
            </el-dialog>
            <el-drawer
                title="优惠券领取记录"
                :visible.sync="recordStutas"
                direction="rtl"
                size="70%"
                :before-close="cloreRecordChange">
                <CouponReceive :couponId='couponId' ref='CouponReceive'></CouponReceive>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { get, post, deleteFun, upload, postJson } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/gidselect.vue';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import CouponReceive from './CouponReceive.vue';
import { PRODUCT, PRODUCT_SEARCH } from '@/utils/constant.js'
export default {
    components: {
        GridSelectLi,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect,
        CouponReceive
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopCouponList();
                this.getShopCouponList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopCouponList();
                this.getShopCouponList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            couponId: '',
            PRODUCT_code: PRODUCT,
            PRODUCT_search: PRODUCT_SEARCH,
            recordStutas: false,
            did: '',
            //禁止当前之前的时间
            disabledCurrentDate: {
                disabledDate: (time) => {
                    return time.getTime() <= new Date().getTime() - 8.64e7;
                }
            },
            //禁止grantTime时间之前的时间
            disabledGrantTime: {
                disabledDate: (time) => {
                    const grantTime = this.shopCoupon.grantTime;
                    const useExpire = this.shopCoupon.useExpire;

                    if (grantTime) {
                        return (
                            // time.getTime() <= new Date(receiveExpire).getTime() - 8.64e7 ||
                            time.getTime() <= new Date(grantTime).getTime() - 8.64e7 || time.getTime() >= new Date(useExpire).getTime()
                        );
                    }
                }
            },
            //禁止receiveExpire时间之前的时间
            disabledReceiveExpire: {
                disabledDate: (time) => {
                    const receiveExpire = this.shopCoupon.receiveExpire;
                    const grantTime = this.shopCoupon.grantTime;

                    if (receiveExpire) {
                        return time.getTime() <= new Date(grantTime).getTime();
                    }
                }
            },
            queryForm: {
                productName: '', //产品
                couponName: '', //优惠券名称
                couponType: '' //优惠券类型
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopCouponState: 'add',
            shopCouponStates: {
                add: '新建优惠券',
                check: '查看优惠券',
                edit: '修改优惠券'
            },

            multipleSelection: [],
            shopCouponList: [],
            shopCoupon: {
                id: '', //优惠券id
                couponName: '', //优惠券名称
                couponMoney: '', //优惠券金额
                couponCategory: null,
                receiveExpire: '', //优惠券领取过期时间
                useExpire: '', //优惠券使用过期时间
                // grantTime: '', //优惠券发放时间
                // couponPhoto: '', //优惠券图片
                couponAmount: '', //优惠券发放数量
                // surplusAmount: '', //优惠券剩余数量
                receiveAmount: 0, //优惠券领取数量
                productId: '', //所属产品
                productName: '',//产品名称
                categoryId: '', //分类id
                couponType: '', //1 是满减   2是无门槛
                couponTarget: '',//优惠券种类
                useRequire: '' //必须满足的金额数
            },
            btnLoading: false,
            rules: {
                couponName: [{ required: true, message: '优惠券名称不能为空', trigger: 'blur' }],
                couponMoney: [{ required: true, message: '优惠券金额不能为空', trigger: 'blur' }],
                receiveExpire: [{ required: true, message: '优惠券领取过期时间不能为空', trigger: 'blur' }],
                useExpire: [{ required: true, message: '优惠券使用过期时间不能为空', trigger: 'blur' }],
                couponAmount: [{ required: true, message: '优惠券发放数量不能为空', trigger: 'blur' }],
                receiveAmount: [{ required: true, message: '优惠券领取数量不能为空', trigger: 'blur' }],
                couponTarget: [{ required: true, message: '优惠券种类不能为空', trigger: 'blur' }],
                categoryId: [{ required: true, message: '优惠券指定的品类不能为空', trigger: 'blur' }],
                productId: [{ required: true, message: '优惠券指定的商品不能为空', trigger: 'blur' }],
                couponType: [{ required: true, message: '优惠券类型不能为空', trigger: 'blur' }],
                useRequire: [{ required: true, message: '优惠券满减金额不能为空', trigger: 'blur' }],
            },
            couponTypeList: [],
            couponTargetList: [],
            shopProductCategoryList: [],
            expands: [],
            treeProps: {
                children: 'children',
                label: 'categoryName'
            },
        };
    },
    created() {
        this.getClassification();
        this.getShopCouponList();
        this.couponTypeEnum();
        this.couponTargetEnum();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopCouponList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopCouponList = [];
        },
        resetDialog() {
            this.shopCouponState = 'add';
            this.showDialog = false;
            this.shopCoupon = {
                id: '', //优惠券id
                couponName: '', //优惠券名称
                couponMoney: '', //优惠券金额
                receiveExpire: '', //优惠券领取过期时间
                useExpire: '', //优惠券使用过期时间
                // grantTime: '', //优惠券发放时间
                // couponPhoto: '', //优惠券图片
                couponAmount: '', //优惠券发放数量
                // surplusAmount: '', //优惠券剩余数量
                receiveAmount: 0, //优惠券领取数量
                productId: '', //所属产品
                productName: '',//产品名称
                categoryId: '', //分类id
                couponType: '', //优惠券类型
                couponTarget: '',//优惠券种类
                useRequire: '' //必须满足的金额数
            };
            this.getShopCouponList();
        },
        //关闭窗口
        closeDialog() {
            this.resetDialog();
            this.$refs.shopCouponForm.resetFields();
        },
        submitForm() {
            // 处理多余参数
            if(this.shopCoupon.couponTarget == 2){
                this.shopCoupon.categoryId = ''
            }
            if(this.shopCoupon.couponTarget == 3){
                this.shopCoupon.productId = ''
            }

            if (this.shopCouponState == 'add') {
                this.$refs.shopCouponForm.validate((valid) => {
                    if (valid) {
                        post(`/washcloud/coupon/add`, { ...this.shopCoupon }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopCouponList();
                                this.resetDialog();
                                this.getShopCouponList();
                            }
                        });
                    }
                });
            } else if (this.shopCouponState == 'edit') {
                this.$refs.shopCouponForm.validate((valid) => {
                    if (valid) {
                        delete this.shopCoupon.shopProduct;
                        console.log({ ...this.shopCoupon });
                        postJson(`/washcloud/coupon/edit`, { ...this.shopCoupon }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopCouponList();
                                this.resetDialog();
                                this.getShopCouponList();
                            }
                        });
                    }
                });
            }
        },
        addShopCoupon() {
            this.showDialog = true;
            this.shopCouponState = 'add';
        },
        checkShopCoupon(shopCouponId) {
            this.currentShopCouponId = shopCouponId;
            this.getShopCouponById();
            this.shopCouponState = 'check';
            this.showDialog = true;
        },
        editShopCoupon(shopCouponId) {
            if (shopCouponId) {
                this.currentShopCouponId = shopCouponId;
                this.getShopCouponById();
            } else {
                this.shopCoupon = { ...this.shopCoupon, ...this.multipleSelection[0] };
            }

            this.shopCouponState = 'edit';
            this.showDialog = true;
        },
        deleteShopCoupon(shopCouponId) {
            let ids = '';
            if (shopCouponId) {
                ids = shopCouponId;
            } else {
                ids = this.multipleSelection.map((shopCoupon) => shopCoupon.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/washcloud/coupon/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopCouponList();
                            this.getShopCouponList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopCouponList() {
            this.resetShopCouponList();
            this.getShopCouponList();
        },
        getShopCouponList() {
            this.loading = true;
            get(`/washcloud/coupon/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                if (res.success && res.code == 200) {
                    this.shopCouponList = res.page.list;
                    this.totalNum = res.page.total;
                }
                this.loading = false;
            });
        },
        getShopCouponById() {
            get(`/washcloud/coupon/get`, { id: this.currentShopCouponId }).then((res) => {
                if (res.success && res.code == 200) {
                    res.shopCoupon.useExpire = this.$moment(res.shopCoupon.useExpire).format('YYYY-MM-DD HH:mm:ss');
                    res.shopCoupon.receiveExpire = this.$moment(res.shopCoupon.receiveExpire).format('YYYY-MM-DD HH:mm:ss');
                    res.shopCoupon.grantTime = this.$moment(res.shopCoupon.grantTime).format('YYYY-MM-DD HH:mm:ss');
                    this.shopCoupon = { ...this.shopCoupon, ...res.shopCoupon };
                    this.shopCoupon.productId = res.shopCoupon.targetId
                    this.shopCoupon.categoryId = res.shopCoupon.targetId
                }
            });
        },
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success && res.code == 200) {
                    this.shopCoupon.couponPhoto = res.url;
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopCouponList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopCouponList();
        },

        // 获取优惠券类型枚举
        couponTypeEnum(){
            get("/mpp/utils/getEnum",{ enumType:"coupon_type" }).then((res)=>{
                if(res.success){
                    this.couponTypeList = res.enumList
                }
            })
        },

        // 获取优惠券分类枚举
        couponTargetEnum(){
            get("/mpp/utils/getEnum",{ enumType:"coupon_target" }).then((res)=>{
                if(res.success){
                    this.couponTargetList = res.enumList
                }
            })
        },

        getValueProductId(value,naem){
            this.shopCoupon.productId = value
            this.shopCoupon.productName = naem
            this.shopCoupon.targetId = value
        },

        couponTargetChange(){
            console.log('11111')
            this.shopCoupon.targetId = this.shopCoupon.categoryId
        },

        getClassification() {
            get(`/washcloud/productcategory/findAllAsTree`).then((res) => {
                if (res.success && res.code == 200) {
                    this.shopProductCategoryList = res.treeData;
                    console.log("res.treeData",res.treeData)
                    res.treeData.forEach((element) => {
                        this.expands.push(element.id);
                    });
                }
            });
        },

        computeCouponType(type){
            for (let i = 0; i < this.couponTypeList.length; i++) {
                if(this.couponTypeList[i].key == type){
                    return this.couponTypeList[i].value
                }
            }
        },

        computeCouponTarget(target){
            for (let i = 0; i < this.couponTargetList.length; i++) {
                if(this.couponTargetList[i].key == target){
                    return this.couponTargetList[i].value
                }
            }
        },

        shopCouponRecord(id){
            this.recordStutas = true
            this.couponId = id
            this.$nextTick(()=>{
                this.$refs.CouponReceive.getShopUserCouponList()
            })
        },
        cloreRecordChange(){
            this.recordStutas = false
            this.couponId = ''
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.coupon-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
</style>
